<template>
    <div>
        <h4 class="card-title">{{ $t('school.digistudies_access') }}</h4>
        <p class="card-description">{{ $t('school.decide_who_has_access_to_digistudies') }}</p>

        <b-tabs class="apprentice-tab">
            <b-tab
                :title="$t('school.students')"
                active>
                <div class="apprentice-simple-card">
                    <design-2021-school-settings-digistudies-access-table-component
                        :people-in="studentsIn"
                        type="student"></design-2021-school-settings-digistudies-access-table-component>
                </div>
            </b-tab>

            <b-tab :title="$t('school.teachers')">
                <div class="apprentice-simple-card">
                    <design-2021-school-settings-digistudies-access-table-component
                        :people-in="teachersIn"
                        type="teacher"></design-2021-school-settings-digistudies-access-table-component>
                </div>
            </b-tab>

            <b-tab :title="$t('school.projects')">
                <div class="apprentice-simple-card">
                    <design-2021-school-settings-digistudies-access-groups-table-component
                        :groups-in="groupsIn"
                        type="group"></design-2021-school-settings-digistudies-access-groups-table-component>
                </div>
            </b-tab>

            <b-tab :title="$t('school.las_groups')">
                <div class="apprentice-simple-card">
                    <design-2021-school-settings-digistudies-access-groups-table-component
                        :groups-in="lasGroupsIn"
                        type="lasGroup"></design-2021-school-settings-digistudies-access-groups-table-component>
                </div>
            </b-tab>

            <b-tab :title="$t('school.las_main_groups')">
                <div class="apprentice-simple-card">
                    <design-2021-school-settings-digistudies-access-groups-table-component
                        :groups-in="lasMainGroupsIn"
                        type="lasMainGroup"></design-2021-school-settings-digistudies-access-groups-table-component>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-settings-digistudies-access-component',
    props: ['studentsIn', 'teachersIn', 'groupsIn', 'lasMainGroupsIn', 'lasGroupsIn'],
};
</script>

<style scoped></style>
